import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { FontAwesomeIcon } from 'components/Utils/FontAwesomeIconWrapper';
import { faClone, faTrash, faChevronRight, faEllipsis } from '@fortawesome/pro-light-svg-icons';

import { Card, Flex, Tag, Dropdown, Button, Space, Tooltip } from 'antd';

import './ProjectItem.sass';

export const ProjectItem = (props: any) => {
	const { t } = useTranslation();

	const menuItems = [
		{
			key: 'clone',
			label: (
				<span onClick={props.onClone} style={{ opacity: !props.onClone ? 0.5 : 1 }}>
					{/* @ts-ignore */}
					<FontAwesomeIcon icon={faClone} style={{ marginRight: 8 }} />
					{t('models.project.actions.clone')}
				</span>
			),
			disabled: !props.onClone,
		},
		{
			key: 'delete',
			label: (
				<span onClick={props.onDelete} style={{ color: '#ff4d4f' }}>
					{/* @ts-ignore */}
					<FontAwesomeIcon icon={faTrash} style={{ marginRight: 8 }} />
					{t('models.project.actions.delete')}
				</span>
			),
		},
	];

	return (
		<Card className={"ProjectItem " + props?.className} title={props?.details?.name} extra={
			<Space>

				<Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
					<Button shape="circle" size="small">
						{/* @ts-ignore */}
						<FontAwesomeIcon icon={faEllipsis} />
					</Button>
				</Dropdown>

				<Tooltip title={t('models.project.actions.open')}>
					<Button
						shape="circle"
						size="small"
						onClick={() => props.onClick(props?.details?.id)}
					>
						{/* @ts-ignore */}
						<FontAwesomeIcon icon={faChevronRight} />
					</Button>
				</Tooltip>
			</Space>
		}>
			<Flex>
				{props?.details?.reference && <>
					<span className="reference">{props?.details?.reference}</span>
					&nbsp;-&nbsp;
				</>}

				<small>
					Created on{' '}
					{dayjs(props?.details?.createdAt).format('DD/MM/YYYY HH:mm')}
				</small>

				{props?.details?.type && <div className="tagWrapper ml-auto">
					<Tag className="type">
						{t("models.project.fields.types." + props?.details?.type)}
					</Tag>
				</div>
				}
			</Flex>
		</Card>
	);
};

export default ProjectItem;
